import { WfeLS } from '@src/state/session/types'
import { getCookieDomain } from '@src/state/site/selectors'
import site from '@src/state/site/site'
import * as cookie from 'js-cookie'

export const WFE_TOKEN_KEY = 'wfeToken'
export const DEBUG_KEY = 'allowDebug'
export const WFE_LS_KEY = 'wfeLS'
export const DEBUG_VALUE = JSON.stringify(true)
export const CHEGG_SESSION_KEY = 'CSessionID'

export type SetLocalStorageData = Partial<WfeLS>

export const getJwt = (): string | null => localStorage.getItem(WFE_TOKEN_KEY)

export const setJwt = (jwt: string): void => localStorage.setItem(WFE_TOKEN_KEY, jwt)

export const clearJwt = (): void => localStorage.removeItem(WFE_TOKEN_KEY)

export const clearJwtLegacyCookie = () =>
  cookie.remove(WFE_TOKEN_KEY, {
    path: '/',
    domain: getCookieDomain(site),
  })

export const allowDebug = () => localStorage.getItem(DEBUG_KEY) === DEBUG_VALUE

export const setWFELS = (session: WfeLS): void => {
  localStorage.setItem(WFE_LS_KEY, JSON.stringify(session))
}

export const getWFELS = (): WfeLS | null => {
  const wfeLs = localStorage.getItem(WFE_LS_KEY)
  return wfeLs ? JSON.parse(wfeLs) : null
}

export const setInLocalStorage = (data: SetLocalStorageData) => {
  const wfeLS = getWFELS()
  let dataToPersist = data
  if (wfeLS) {
    dataToPersist = { ...dataToPersist, ...data }
  }
  localStorage.setItem(WFE_LS_KEY, JSON.stringify(dataToPersist))
}

// cleared on log out
export const clearWfeLS = () => localStorage.removeItem(WFE_LS_KEY)

export const getCheggSessionId = () => cookie.get(CHEGG_SESSION_KEY)



// WEBPACK FOOTER //
// ./src/utils/localStorage.ts